
import {Component, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {dataFieldsEditModule} from "@/store";
import dataFieldTypes from "@/dataFieldTypes";

@Component({
  name: 'DataFields',
  components: {
    ...dataFieldTypes,
    OkDialog
  },
})
export default class DataFields extends Vue {

  get dataFields() {
    return dataFieldsEditModule.dataFields;
  }
}
